module.exports = __webpack_public_path__ + "static/media/m8.24026610.jpg";